import React from 'react';
import { withRouter } from 'react-router-dom';
// ANTD
import Icon from 'components/common/Icon';

// EXPORTED COMPONENT
// ==============================
class BackButton extends React.PureComponent {
  render() {
    return (
      <a href="#" onClick={() => this.props.history.goBack()} style={this.props.style}>
        <Icon type="arrow-left" /> Back
      </a>
    );
  }
}

// PROPS
// ==============================
BackButton.defaultProps = {
  style: {
    margin: 10,
    display: 'inline-block',
  },
};
BackButton.propTypes = {};

// EXPORT
// ==============================
export default withRouter(BackButton);



// WEBPACK FOOTER //
// ./src/components/common/BackButton/index.js